export const getVisibleItems = (items, values) =>
  items.filter(item => item.isVisible || values.includes(item.value));
